<template>
  <!-- <div class="vl-parent"> -->
  <Loading
    v-model:active="dialogs.loader"
    loader="dots"
    :background-color="isInDarkMode ? '#000' : '#FFF'"
    :color="isInDarkMode ? '#FFF' : '#000'"
    :opacity="0.88"
    :z-index="999998"
    style="z-index: 999998"
    :is-full-page="true"
  >
    <v-row align="center" justify="center">
      <img :src="Logo" width="100px" height="100px" class="rotatinglogo" />
      <!-- <v-icon class="charging" size="large">mdi-ev-plug-ccs2</v-icon> -->
      <span>
        {{ dialog.options && dialog.options.message ? dialog.options.message : msg }}
      </span>
    </v-row>
  </Loading>
  <!-- </div> -->
  <!-- <div id="loader-wrapper">
    <v-card class="loader-card-back">
    <v-row class="loader-card">
      <v-col class="subtitle-1 text-center white--text" cols="12">
        <span class>{{ msg }}</span>
      </v-col>
      <v-col cols="12">
        <v-progress-linear v-if="linear" style="background-color: rgb(18, 77, 104);" indeterminate color="light-blue" height="10" striped></v-progress-linear>
        <v-row v-else justify="center">
          <v-progress-circular :size="70" :width="7" color="light-blue" indeterminate></v-progress-circular>
        </v-row>
      </v-col>
    </v-row>
    </v-card>
  </div>-->
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import { dialogs } from "./global_dialog";

export default {
  components: {
    Loading,
  },
  props: {},
  data() {
    return {
      Logo: require("@/assets/darkLogo.png"),
      dialogs: dialogs,
      msg: {
        type: String,
        default: "Зареждане на информация...",
      },
    };
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {
    if (this.dialog.options && this.dialog.options.message) {
      this.msg = this.dialog.options.message;
    }
  },
  watch: {},
};
</script>

<style>
.vld-icon {
  text-align: center;
}
/* #loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.loader-card-back {
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
}
.loader-card {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9;
} */

.rotatinglogobackground {
  background-color: white;
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(5px);
  opacity: 0.93;
}
.rotatinglogocontainer .rotatinglogo {
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  text-align: center;
  z-index: 1;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
}

.rotatinglogo {
  position: relative;
  display: inline-block;
  z-index: 2147483647;
  -moz-animation: rotatinglogo 1s linear infinite;
  -webkit-animation: rotatinglogo 1s linear infinite;
  animation: rotatinglogo 1s linear infinite;
}

@-moz-keyframes rotatinglogo {
  0% {
    -moz-transform: rotate(0deg);
  }
  50% {
    -moz-transform: rotate(90deg) scale(0.7);
  }
  100% {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes rotatinglogo {
  0% {
    -webkit-transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(90deg) scale(0.7);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes rotatinglogo {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(90deg) scale(0.7);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>./global_dialog